import React from 'react';
import {
  Banner,
  Spinner
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import { AppContext } from '../../common/AppContext';

export class RequiredDataProgress extends React.Component {

  state = {
    isInit: false,
  };

  render() {

    const downloadingData = Object
      .getOwnPropertyNames(this.context.requiredData)
      .filter(_ => _ === "Products" || _ === "Customers" || _ === "Orders")
      .filter(_ => !this.context.requiredData[_])
      .map(_ => _);

    return (
      <div>
        <Banner status="critical" onDismiss={() => { }} 
        action={{ content: "Have questions? Chat with us!", onAction: this.onChatWithUs }}>
          <p>
            We are currently fetching data from your store.
            Feel free to take a look around but in order for the app to work correctly the data must be ready first.
            The estimated wait time is 5 minutes.
            <br/>
            <br/>
            We are currently fetching: {downloadingData} <Spinner size="small" />
          </p>
        </Banner>
        <br />
      </div>
    );
  }

  fetchDashboardData = () => {
    fetch('api/storeConnections/info')
      .then(response => { return response.json() })
      .then(data => {

        if (data.isInit) {
          clearInterval(this.timerID);
          this.context.updateInitState(data.isInit, data.requestData);
          this.props.onDone();
        } else {
          this.timerID = setTimeout(
            () => this.fetchDashboardData(),
            15000)
        };
      });
  }

  onChatWithUs = () => {
    window.$crisp.push(["do", "chat:open"]);
  }

  componentDidMount = () => {
    this.fetchDashboardData();
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

}

RequiredDataProgress.contextType = AppContext;

export default RequiredDataProgress;